import { useEffect, useMemo, useState } from 'react';
import HeadTitle from '../../components/HeadTitle';
import CountryTotalUsers from '../../components/location-insights/CountryTotalUsers';
import WorldMap from '../../components/analytics-and-insights/WorldMap';
import SearchFilter from '../../components/analytics-and-insights/SearchFilter';
import { useSelector } from 'react-redux';
import { fetchRegionData } from '../../api/region';
import LocationInsightsSkeleton from './LocationInsightsSkeleton';

const LocationInsights = () => {
  const [loading, setLoading] = useState(true); 
  const [components] = useState([
    {
      id: 1,
      imageSrc: '/assets/images/admin-panel/map.png',
      text: 'Location Insights',
      // description:
      //   'A feature like "Location-Wise Activity" can offer insights into user engagement and behavior based on their geographic location. Heres how it could be structured',
    },
  ]);

  // const { filter } = useSelector((state) => state);
    const filter = useSelector((state) => state.filter);
    const filterWithoutUTM = useMemo(() => {
      const { utm_options, ...rest } = filter;
      return rest;
    }, [JSON.stringify(filter)]);

  const [countryData, setCountryData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);

  const fetchData = async () => {
    try {
      const data = await fetchRegionData(filter);
      const transformedCountryData = data.countryCount.map((item) => ({
        y: item.userCount,
        category: item.country,
        color: '#2E80DB',
      }));

      const transformedStateData = data.stateCount.map((item) => ({
        y: item.userCount,
        category: item.state,
        color: '#C19D9E',
      }));

      const transformedCityData = data.cityCount.map((item) => ({
        y: item.userCount,
        category: item.city,
        color: '#F2D28C',
      }));

      setCountryData(transformedCountryData);
      setStateData(transformedStateData);
      setCityData(transformedCityData);
      setTotalUsers(data.totalUsers);
    } catch (error) {
      console.error('Error while fetching data', error);
    }
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [JSON.stringify(filterWithoutUTM)]);

  if (loading) return <LocationInsightsSkeleton />;

  return (
    <div>
      {/* Dynamically Render Components */}
      {components.map((component) => (
        <HeadTitle
          key={component.id}
          imageSrc={component.imageSrc}
          text={component.text}
          description={component.description}
        />
      ))}

      {/* <div className="d-flex gap-2 justify-content-between align-items-center py-16">
        <div className="">
          <span className="badge text-md fw-medium bg-warning-900 px-20 py-9 radius-8 text-white">Overall</span>
        </div>

        <div className="d-flex gap-2 justify-content-between align-items-center">
          <div className="bg-light-100 d-flex align-items-center gap-3 pe-20 radius-6">
            <CountrySelect /> <FilterState />
          </div>
          <BasicRangeShortcuts id="range1" />
          <button className="badge text-sm fw-medium bg-light-100 px-20 py-12 radius-6 text-secondary-light">Male</button>
          <button className="badge text-sm fw-medium bg-light-100 px-20 py-12 radius-6 text-secondary-light">Female</button>
          <button className="badge text-sm fw-medium border border bg-transparent px-20 py-12 radius-6 text-secondary-light">Reset</button>
        </div> 
      </div> */}

      <SearchFilter />

      <div className="">
        <CountryTotalUsers
          data={countryData}
          title="Country Wise Users"
          subtitle={`${totalUsers} Users`}
        />
      </div>

      <div className="d-flex justify-content-between align-items-center gap-2 my-24">
        <div className="w-100">
          <CountryTotalUsers
            data={stateData}
            title="State Wise Users"
            subtitle={`${totalUsers} Total Users`}
          />
        </div>
        <div className="w-100">
          <CountryTotalUsers
            data={cityData}
            title="City Wise Users"
            subtitle={`${totalUsers} Total Users`}
          />
        </div>
      </div>
      <div className="">
        <WorldMap showDetails={false} />
      </div>
    </div>
  );
};

export default LocationInsights;
